import React from 'react';
import Link from 'gatsby-link';
import styles from './styles.module.css';

import TEXT from '../../../../../data/text.json';

import TextBox from '../../../../components/contribution-form/form-components/text-box';
import TextArea from '../../../../components/contribution-form/form-components/text-area';
import EmailNotice from '../../../../components/contribution-form/form-components/email-notice';
import PillButton from '../../../../components/pill-button';
import Tooltip from '../../../../components/Tooltip';

export default ({
  emailValue,
  messageValue,
  onChange,
  formValid,
  formValidationMessage,
  submit,
}) => {
  const submitButton = (
    <PillButton
      type="submit"
      preventDefault
      text="Submit"
      onClick={submit}
      disabled={!formValid}
    />
  );

  return (
    <div className={styles.container}>
      <p>
        If you have any questions, comments or suggestions related to the
        website feel free to contact us using the form below. Please provide a
        valid email address so that we can get back to you if we need to.
      </p>
      <TextBox
        type="email"
        id={TEXT.FORMS.emailId}
        label={TEXT.FORMS.emailLabel}
        placeholder={TEXT.FORMS.emailPlaceholder}
        value={emailValue}
        onChange={event => onChange('emailValue', event.target.value)}
      />
      <EmailNotice />
      <TextArea
        id="message"
        label="Your Message"
        placeholder="Enter your message..."
        value={messageValue}
        onChange={event => onChange('messageValue', event.target.value)}
      />

      {/* If the submit button is disabled then wrap it in a tooltip */}
      {!formValid ? (
        <Tooltip text={formValidationMessage}>{submitButton}</Tooltip>
      ) : (
        submitButton
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/page-components/contact-us/contact-form/input-stage/index.js